export enum SentExternalLaboratoryStatusEnum {
    Send=  1,
    Receive = 2,
    Cancelled = 3,
    Pending = 4
}
